import { useGlobalData } from "@/contexts/GlobalData";
import { useRealtimeData } from "@/contexts/RealtimeData";
import clsx from "clsx";
import { Fragment, useEffect, useState } from "react";
import Accordion from "../Accordion";
import DepositFunction from "../DepositFunction";
import DynamicFontSize from "../DynamicFontSize";
import DynamicSizeIcon from "../DynamicSizeIcon";
import FormatterNumber from "../FormatterNumber";
import LineContentValue from "../LineContentValue";
import TimeLine from "../TimeLine";
import UnderlineText from "../UnderlineText";
import { cn } from "@/lib/utils";
import LineContentValueV2 from "../LineContentValueV2";
import LeftGradientBorder from "../LeftGradientBorder";
import { CircularProgress } from "@nextui-org/react";
import { FeesType } from "@/common/types";
type FeesBlock = {
  children?: React.ReactNode;
  fees?: FeesType | null;
  validBalance?: any;
  prefix?: string;
  amount?: number;
  couponDiscount?: number;
  useLineContentValueV2?: boolean;
  currency?: string;
  loadingFees?: boolean;
  background?: any;
  className?: string;
  compact?: boolean;
  isFree?: boolean;
};
function FeesBlock({
  fees,
  validBalance,
  prefix,
  amount,
  couponDiscount = 0,
  useLineContentValueV2 = false,
  currency,
  loadingFees,
  background = "left_to_right",
  className,
  compact = true,
  isFree = false,
  children
}: FeesBlock) {
  const {
    getIcon,
    translate
  } = useGlobalData();
  const {
    tokensRateState
  } = useRealtimeData();
  const LineContent = useLineContentValueV2 ? LineContentValueV2 : LineContentValue;
  if (fees && fees?.settingFee?.length == 0) return;
  return <LeftGradientBorder background={background} className={cn("p-3 flex flex-col gap-2 mt-2", className)} data-sentry-element="LeftGradientBorder" data-sentry-component="FeesBlock" data-sentry-source-file="index.tsx">
            <Accordion defaultExpanded={!validBalance?.["all"]} expandableHeight={-1} //disable max height
    disableChangeStatus={isFree} leftPart={<LineContent className="flex-1 mr-2" field={translate(prefix + "Total Fee")} value={isFree ? children : <Fragment>
                                    {!loadingFees && <FormatterNumber lengthValueAllowed={8} value={Number(fees?.finalFee) * (1 - couponDiscount) || 0} start={currency ? `` : "$"} disableTooltip unit={currency ? ` ${currency}` : ``} useCompact={compact} />}
                                    {loadingFees && <CircularProgress classNames={{
        svg: "text-white !size-6"
      }} />}
                                </Fragment>}></LineContent>} rightPart={<DynamicSizeIcon className={clsx({
      "duration-300 rotate_icon_0 rotate-180": true,
      "rotate-90": isFree
    })} width={9.4} height={5.4} icon={getIcon("arrow_accordion")} />} data-sentry-element="Accordion" data-sentry-source-file="index.tsx">
                {fees && <>
                        <TimeLine className="flex flex-col gap-2 text-description mt-2" length={fees?.settingFee?.length}>
                            {fees?.settingFee?.map?.((item: any) => {
            const rate = tokensRateState?.[item?.currency?.symbol]?.USD;
            return <LineContentValue key={item.id} field={translate(item?.fee_type?.key)} value={<div className="flex items-center gap-1">
                                                {!!couponDiscount && <FormatterNumber
              // isLessThan
              lengthValueAllowed={8} value={(Number(amount) * item?.percent * 0.01 / rate + item?.fixed) * (1 - couponDiscount)} unit={` ${item?.currency?.symbol}`} useCompact={compact} />}
                                                <p className={cn(!!couponDiscount && "relative after:absolute after:left-0 after:bg-white after:w-full after:h-[1px] after:top-1/2 after:-translate-y-1/2 after:z-10")}>
                                                    <FormatterNumber className={!validBalance?.[item?.currency?.symbol] ? "!text-error" : ""} disableAdjustUnitColor
                // isLessThan
                lengthValueAllowed={8} value={Number(amount) * item?.percent * 0.01 / rate + item?.fixed} unit={` ${item?.currency?.symbol}`} useCompact={compact} />
                                                </p>
                                            </div>} valueDescription={<FormatterNumber
            // isLessThan
            lengthValueAllowed={8} value={(Number(amount) * item?.percent * 0.01 + item?.fixed * rate) * (1 - couponDiscount)} start="~ $" useCompact={compact} />}></LineContentValue>;
          })}
                        </TimeLine>
                        {!validBalance?.["all"] && <DynamicFontSize fontSize={12} className="text-error italic font-light">
                                {translate(prefix + "insufficient balance fee")}
                                <DepositFunction className="inline" showOptions>
                                    <UnderlineText className="!text-error !italic !font-medium">
                                        {translate(prefix + "deposit")}
                                    </UnderlineText>
                                </DepositFunction>
                                {translate(prefix + "to continue")}
                            </DynamicFontSize>}
                    </>}
            </Accordion>
        </LeftGradientBorder>;
}
export default FeesBlock;